<span class="priority-badge body-medium-emphasized" [ngClass]="getCssClass()">
  {{ getLabel() }}
</span>
